<fgsn-ecommerce-website-header />
<main class="main_wrapper">
  <router-outlet />
</main>
<fgsn-ecommerce-website-footer />
